import { watch } from '../utilities/watch';
import { FormAssociatedMixin } from './form_associated_mixin';

/**
 * A mixin that adds required field validation capabilities to a form associated element
 * @param {typeof HTMLElement} superClass - The class to extend
 * @returns {typeof HTMLElement} A class with required field validation capabilities
 */
export function FormAssociatedRequiredMixin(superClass) {
  class FormAssociatedRequiredElement extends FormAssociatedMixin(superClass) {
    /**
     * @returns {Object} Property definitions for the required attribute
     */
    static get properties() {
      return {
        required: { type: Boolean, reflect: true },
      };
    }

    /**
     * Sets up required field validation
     */
    constructor() {
      super();
      watch(this, 'required', 'requiredChange', { waitUntilFirstUpdate: true });
      this.required = false;
    }

    /**
     * Handles changes to the required attribute by updating validity state
     */
    requiredChange() {
      this.updateValidity();
      this.invalid = !this.checkValidity();
    }
  }

  return FormAssociatedRequiredElement;
}
